<template>
  <div class="landing-section">
    <video ref="bg-video" class="bg-video" autoplay muted loop>
      <source src="@/assets/bg-stars.mp4" type="video/mp4" />
    </video>
    <div class="content">
      <h1>I N T E R S T E L L A R</h1>
      <p></p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.landing-section {
  width: 100vw;
  height: 100vh;
  display: flex;
  background: url("@/assets/bg-stars.mp4");
  background-size: cover;

  align-items: center;
  justify-content: center;

  .bg-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -1;
  }

  .content {
    font-size: 170px;
    flex-wrap: wrap;
    text-align: center;

    h1 {
      font-size: 170px;
    }

    @media screen and (max-width: 480px) {
      h1 {
        font-size: 5vw;
      }
    }
  }
}
</style>
